// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2f2a1705","389":"c3a69d82","453":"45d33666","455":"23dd9265","977":"9489694b"}[chunkId] + ".chunk.js";
};